
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(5(13|18|47|79)|(41|76|91)4|021|13|479|698|790|826)|2(84[02]|(09|1|55|94)0|133|374|426|619|638)|5(96[36]|19[48]|3(09|78|79)|6(26|37|4|91)|098|282|583)|6(3(|8|9)8|(13|42|95)0|(09|53|78)8|((|1|5)2|73)2|419|974)|1(7(15|33|89)|146|355|657|912)|8(02[56]|7(34|48|68)|154|206|430|602|63|926|992)|7((3|47|91)8|(20|65|79)3|(40|63|80)2|195|531|547)|3(44[23]|27[08]|1(06|36|54)|9(2|34|43|9)|342|37|535|63|697|721|781)|9(258|34|389|446|457|614|786|9|900))$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
